import lassoBrushComponent from './brush-lasso';

export default function lassoBrush(picasso) {
  picasso.component('brush-lasso', lassoBrushComponent);
}
